import { FieldHelperText, FieldProps, LabelWithIconAndTooltip } from "@firecms/core";
import { Container, MapIcon, Select, SelectItem, TextField } from "@firecms/ui";
import { useMemo, useState } from "react";
import timezones from "timezones-list";

import { Timezone } from "@/collections/connections";

export const TimezoneField = (props: FieldProps<Timezone>) => {
  const { value, setValue, propertyKey, property, includeDescription, showError, error } = props;
  const [search, setSearch] = useState("");

  const filteredTimezones = useMemo(() => {
    if (!search) return timezones;
    const lower = search.toLowerCase();
    return timezones.filter(
      (tz) =>
        tz.label.toLowerCase().includes(lower) ||
        tz.tzCode.toLowerCase().includes(lower) ||
        tz.name.toLowerCase().includes(lower),
    );
  }, [search]);

  return (
    <>
      <LabelWithIconAndTooltip
        icon={<MapIcon size="small" />}
        propertyKey={propertyKey}
        title={property.name || "Timezone"}
      />
      <Select
        placeholder={value?.tzCode || "Select timezone"}
        fullWidth={true}
        dataType={"string"}
        position={"popper"}
        value={value?.tzCode || ""}
        onValueChange={(selectedValue) => {
          const selectedTz = timezones.find((tz) => tz.tzCode === selectedValue);
          if (selectedTz) {
            setValue(selectedTz);
            setSearch("");
          }
        }}
      >
        <Container className="w-full m-1">
          <TextField
            type="text"
            placeholder="Search timezone..."
            className={"mb-2"}
            width="100%"
            value={search}
            autoFocus={true}
            onChange={(e) => {
              setSearch(e.target.value);
              e.stopPropagation();
            }}
          />
          <Container>
            {filteredTimezones.slice(0, 12).map((tz) => (
              <SelectItem key={tz.tzCode} value={tz.tzCode}>
                {tz.label}
              </SelectItem>
            ))}
          </Container>
        </Container>
      </Select>
      <FieldHelperText
        includeDescription={includeDescription}
        showError={showError}
        error={error}
        property={property}
      />
    </>
  );
};
